// src/hooks/useSettingsUsersPermissions.ts
import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { SETTINGS_PERMISSIONS } from '../constants/permissions.constants';

/**
 * Hook for user-management UI actions.
 *
 * Users is menu-only (todo o nada): `settings.users-management.view` grants
 * add / export / delete. Granular `.add` / `.export` / etc. are not assignable.
 */
export const useSettingsUsersPermissions = () => {
  const canManageUsers = usePermission(SETTINGS_PERMISSIONS.USERS.VIEW);

  return useMemo(
    () => ({
      canAddUser: canManageUsers,
      canExportUsers: canManageUsers,
      canDeleteUsers: canManageUsers,
    }),
    [canManageUsers],
  );
};
